/** SpreadsheetML (.xls) helpers for subscription run sheet — opens in Excel. */

function xmlEscape(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function spreadsheetRow(values, { header = false } = {}) {
  const cells = values.map((value) => {
    const raw = String(value ?? '');
    if (!raw) return '<Cell/>';
    const styleAttr = header ? ' ss:StyleID="header"' : '';
    const asText = header || !/^-?\d+(\.\d+)?$/.test(raw);
    const type = asText ? 'String' : 'Number';
    return `<Cell${styleAttr}><Data ss:Type="${type}">${xmlEscape(raw)}</Data></Cell>`;
  }).join('');
  return `<Row>${cells}</Row>`;
}

export const RUN_SHEET_EXCEL_HEADERS = [
  'Date',
  'Order ID',
  'Drop ID',
  'Kind',
  'Brand',
  'Item',
  'Qty',
  'Slot',
  'Phone',
  'Address',
  'Rider',
];

export function dropToExcelRow(drop, date) {
  return [
    date || drop.dropDate || '',
    drop.orderId || '',
    drop.id || '',
    drop.kind || '',
    drop.brand || '',
    drop.itemName || '',
    drop.qty ?? '',
    drop.slotLabel || 'Morning',
    drop.customerPhone || '',
    drop.address || '',
    drop.riderName || '',
  ];
}

export function buildRunSheetWorkbook(date, drops) {
  const rows = (drops || []).map((d) => dropToExcelRow(d, date));
  return `<?xml version="1.0" encoding="UTF-8"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:o="urn:schemas-microsoft-com:office:office"
 xmlns:x="urn:schemas-microsoft-com:office:excel"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:html="http://www.w3.org/TR/REC-html40">
 <Styles>
  <Style ss:ID="header">
   <Font ss:Bold="1"/>
  </Style>
 </Styles>
 <Worksheet ss:Name="Run sheet">
  <Table>
   ${spreadsheetRow(RUN_SHEET_EXCEL_HEADERS, { header: true })}
   ${rows.map((row) => spreadsheetRow(row)).join('\n   ')}
  </Table>
 </Worksheet>
</Workbook>`;
}

export function downloadRunSheetExcel(date, drops) {
  const xml = buildRunSheetWorkbook(date, drops);
  const blob = new Blob([xml], { type: 'application/vnd.ms-excel' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `subs-run-sheet-${date || 'export'}.xls`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
